var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg19276499341600459971(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CDCCCA",
    d: "M200.3 372.7h111V450h-111z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E6E4E5",
    d: "M158.7 439.5h194.2v17.6H158.7zM8 59.9h495.6v328.6H8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#3B424A",
    d: "M18.6 69.5h474.5V350H18.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#92E0EA",
    d: "M43.3 86.6h425v238.6h-425z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M388.3 208c-4-2.3-4.9-6.2-4.9-8.9s.9-6.6 4.9-8.9c6.5-3.7 18.7-4.2 26.2-16.4s4.7-28 4.7-28h-88.3s-2.8 15.9 4.7 28 19.6 12.6 26.2 16.4c4 2.3 4.9 6.2 4.9 8.9s-.9 6.6-4.9 8.9c-6.5 3.7-18.7 4.2-26.2 16.4-7.5 12.1-4.7 28-4.7 28h88.3s2.8-15.9-4.7-28c-7.5-12.2-19.7-12.7-26.2-16.4z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#77D0DE",
    d: "M334 238.4h81.9v11.1H334z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M324.9 135.1h100.2v7.9H324.9zM324.9 254.9h100.2v7.9H324.9zM236.4 115h28v24.5h-28z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#77D0DE",
    d: "M72.9 120.3h145.8v14H72.9zM378.2 201.1c0 1.4-1.2 2.6-2.6 2.6-1.4 0-2.6-1.2-2.6-2.6 0-1.4 1.2-2.6 2.6-2.6 1.4 0 2.6 1.2 2.6 2.6zM378.2 208.3c0 1.4-1.2 2.6-2.6 2.6-1.4 0-2.6-1.2-2.6-2.6 0-1.4 1.2-2.6 2.6-2.6 1.4.1 2.6 1.2 2.6 2.6zM378.2 215.6c0 1.4-1.2 2.6-2.6 2.6-1.4 0-2.6-1.2-2.6-2.6 0-1.4 1.2-2.6 2.6-2.6 1.4 0 2.6 1.1 2.6 2.6zM378.2 222.8c0 1.4-1.2 2.6-2.6 2.6-1.4 0-2.6-1.2-2.6-2.6 0-1.4 1.2-2.6 2.6-2.6 1.4 0 2.6 1.1 2.6 2.6zM378.2 234.5c0 1.4-1.2 2.6-2.6 2.6-1.4 0-2.6-1.2-2.6-2.6 0-1.4 1.2-2.6 2.6-2.6 1.4 0 2.6 1.2 2.6 2.6z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#77D0DE",
    d: "M406 176.3c.7-.7.9-1.8 1.2-2.7h-64.5c.3.9.5 2 1.2 2.7 8.7 9.3 19.1 9.7 23.8 12.8 2.9 1.9 3.5 6.2 3.6 8.4 0 .6-.1 1.5-.2 2.5 1.3.1 2.7.2 4 .2 1.6 0 3.1-.1 4.6-.3-.1-1-.2-1.9-.2-2.4 0-2.2.6-6.5 3.6-8.4 4.7-3.2 14.1-3.1 22.9-12.8z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#F77B55",
    d: "M249.5 136.2l-10.2-9.7 2.5-2.7 7.4 7 10.1-12.3 2.8 2.3z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M236.4 153h28v24.5h-28z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#77D0DE",
    d: "M72.9 158.3h145.8v14H72.9z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#F77B55",
    d: "M249.5 174.1l-10.2-9.6 2.5-2.7 7.4 6.9 10.1-12.3 2.8 2.4z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M236.4 190.9h28v24.5h-28z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#77D0DE",
    d: "M72.9 196.2h145.8v14H72.9z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#F77B55",
    d: "M249.5 212.1l-10.2-9.7 2.5-2.6 7.4 6.9 10.1-12.3 2.8 2.3z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M236.4 228.9h28v24.5h-28z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#77D0DE",
    d: "M72.9 234.2h145.8v14H72.9z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M236.4 266.9h28v24.5h-28z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#77D0DE",
    d: "M72.9 272.2h145.8v14H72.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg19276499341600459971);
export default __webpack_public_path__ + "static/media/19276499341600459971.d4eb9c32d0e505dc5f71558ed955ff1f.svg";
export { ForwardRef as ReactComponent };